export class Logger {
    constructor() {
        this.showDebug = true;
    }
    debug(TAG, ...args) {
        if (!this.showDebug) {
            return;
        }
        // tslint:disable-next-line:no-console
        console.log(`[DEBUG]`, TAG, ...args);
    }
    info(TAG, ...args) {
        // tslint:disable-next-line:no-console
        console.log(`[INFO]`, TAG, ...args);
    }
    error(TAG, ...args) {
        // tslint:disable-next-line:no-console
        console.error(`[ERROR]`, TAG, ...args);
    }
    warn(TAG, ...args) {
        // tslint:disable-next-line:no-console
        console.warn(`[WARN]`, TAG, ...args);
    }
}
